import {
  HomeOutlined,
  BarChartOutlined,
  BankOutlined,
  ScheduleOutlined,
  MoneyCollectOutlined,
  FileTextOutlined,
  RollbackOutlined,
  SyncOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";
import { ItemType } from "antd/es/menu/interface";
import { Link } from "react-router-dom";


export const baseMenuItems: ItemType[] = [
  {
    key: "1",
    icon: <HomeOutlined />,
    label: <Link to="/">Inicio</Link>,
  },
  //key 2 en menuAdmin
  {
    key: "3",
    icon: <BarChartOutlined />,
    label: <Link to="/consulta-stock">Consulta de Stock</Link>,
  },
  {
    key: "4",
    icon: <BankOutlined />,
    label: "Cajas",
    children: [
      {
        key: "4.1",
        icon: <ScheduleOutlined />,
        label: <Link to="/turnos">Turnos</Link>,
      },
      {
        key: "4.2",
        icon: <MoneyCollectOutlined />,
        label: <Link to="/cajas">Cajas</Link>,
      },
    ]
  },
  {
    key: "5",
    icon: <FileTextOutlined />,
    label: "Gestión",
    children: [
      {
        key: "5.1",
        icon: <MoneyCollectOutlined />,
        label: <Link to="/aperturas-caja">Aperturas de Caja</Link>,
      },
      {
        key: "5.2",
        icon: <MoneyCollectOutlined />,
        label: <Link to="/cierres-caja">Cierres de Caja</Link>,
      },
      {
        key: "5.3",
        icon: <FileTextOutlined />,
        label: <Link to="/facturas">Facturas</Link>,
      },
      {
        key: "5.4",
        icon: <RollbackOutlined />,
        label: <Link to="/abonos">Abonos</Link>,
      },
      {
        key: "5.5",
        icon: <SyncOutlined />,
        label: <Link to="/facturas-pendientes">Pendientes de Sincronizar</Link>,
      },
    ],
  },
  {
    key: "6",
    icon: <FileDoneOutlined />,
    label: <Link to="/informes">Informes</Link>
  },
];
